import React from 'react';
import type { SelectChangeEvent } from '@mui/material';
import {
  Box,
  TableFooter as MuiTableFooter,
  Select,
  MenuItem,
} from '@mui/material';
import { useQueryParams } from '../../../../providers/QueryParamsProvider';
import PageSelector from './PageSelector';
import { Show } from '../../../../Show';
import { useTableState } from '../../providers/TableStateProvider';

const TableFooter = () => {
  const queryParams = useQueryParams();
  const tableState = useTableState();
  const [rowsPerPage, setRowsPerPage] = React.useState(queryParams.query.size);

  function handleRowsPerPageChange(event: SelectChangeEvent<any>) {
    const value = event.target.value as number;
    setRowsPerPage(value);
    queryParams.push({}, { query: { ...queryParams.query, size: value } });
  }

  return (
    <MuiTableFooter
      sx={{
        padding: '0.75rem 1rem',
        position: 'relative',
        borderTop: (theme) =>
          `1px solid ${theme.serviceTable.footer.borderColor}`,
      }}
    >
      <Show when={Boolean(tableState?.data)}>
        <PageSelector />
      </Show>
      <Box display="flex" alignItems="center" gap="0.5rem">
        Rows per page:
        <Select
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
          sx={{
            '& .MuiSelect-select': {
              minHeight: '0.35rem',
              height: '0.50rem',
            },
          }}
        >
          {[10, 25, 50, 100].map((val) => (
            <MenuItem value={val} key={val}>
              {val}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </MuiTableFooter>
  );
};

export default TableFooter;
